import { _pejerProvider, defaultPejerState, usePejerBase } from 'pejer/src/stores/pejerData'
import { Router } from 'vue-router'
import { PejerEmbeddables } from './PejerEmbeddables'
import { config } from './config'

export const pejerProvider = (router: Router) => {
  const pejer = new PejerEmbeddables(
    {
      ...defaultPejerState,
      data: {},
      settings: {
        disableQueryParams: true,
      },
    },
    router
  )
  return _pejerProvider(pejer as any, config)
}

export const usePejer = () => {
  const pejer = usePejerBase() as unknown as PejerEmbeddables
  if (!pejer.config) throw new Error('Pejer config not set')

  return pejer
}

export { config }
